import { render, staticRenderFns } from "./DraftTripStatusChip.vue?vue&type=template&id=415eb860"
import script from "./DraftTripStatusChip.vue?vue&type=script&lang=js"
export * from "./DraftTripStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports